<div class="deletePopup" style="font-family: Poppins;border-radius: 10px;">
    <div class="d-flex justify-content-between align-items-center" style="background-color: #F6F8FB;border-radius: 10px 10px 0 0;">
        <div class="p-2">
            <span style="font-size: 15px;font-weight: 600;">Edit Record</span>
        </div>
        <div class="p-2">
            <mat-icon mat-dialog-close class="close-icon" style="color: rgba(138, 152, 171, 1);transition: none;" >close</mat-icon>
        </div>
    </div>
    <form #editForm="ngForm" (ngSubmit)="onSave()" novalidate>
      <div class="my-2 px-3" style="font-weight: 500; font-size: 12px;">

          <!-- Filetype Field -->
          <div class="form-group-edit-grid">
            <mat-label class="du-edit-grid-label">Filetype</mat-label>
            <input
              type="text"
              placeholder="Filetype name..."
              [(ngModel)]="record.filetype"
              name="filetype"
              required
              disabled
            />
          </div>

          <!-- Target Payment Field -->
          <div class="form-group-edit-grid">
            <mat-label class="du-edit-grid-label">Target Payment</mat-label>
            <input
              type="number"
              placeholder="$0"
              [(ngModel)]="record.targetPayment"
              name="targetPayment"
              #targetPayment="ngModel"
              required
            />

            <!-- Validation messages -->
            <div class="error-msg" *ngIf="targetPayment.invalid && (targetPayment.dirty || targetPayment.touched)">
              <small *ngIf="targetPayment.errors?.['required']">Target payment is required.</small>
              <small *ngIf="targetPayment.errors?.['min']">Target payment must be greater than 0.</small>
            </div>
          </div>

        </div>
        <div class="d-flex justify-content-around align-items-center text-center" style="padding: 0 15px 15px;">
            <div style="margin: 5px;">
                <button type="button" class="btn btn-outline-secondary alert-action-btnDelete" mat-dialog-close>Cancel</button>
            </div>
            <div style="margin: 5px;">
                <button type="button" class="btn btn-primary alert-action-btnDelete" [disabled]="editForm.invalid" type="submit" style="background-color: #1363DF;">Update</button>
            </div>
        </div>
      </form>
</div>